import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, LogIn } from 'lucide-react';
interface NavigationProps {
  onLoginClick?: () => void;
}
export function Navigation({
  onLoginClick
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const links = [{
    name: 'How it Works',
    href: '#how-it-works'
  }, {
    name: 'For Brands',
    href: '#brands'
  }, {
    name: 'For Organizers',
    href: '#organizers'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-900/80 backdrop-blur-md border-b border-slate-800" data-id="element-806">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-807">
        <div className="flex items-center justify-between h-20" data-id="element-808">
          {/* Logo */}
          <div className="flex-shrink-0" data-id="element-809">
            <a href="#" className="text-2xl font-bold tracking-tight text-white" data-id="element-810">
              Sponsr<span className="text-cyan-500" data-id="element-811">AI</span>
            </a>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block" data-id="element-812">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-813">
              {links.map(link => <a key={link.name} href={link.href} className="text-slate-300 hover:text-cyan-400 transition-colors px-3 py-2 rounded-md text-sm font-medium" data-id="element-814">
                  {link.name}
                </a>)}
              <button onClick={onLoginClick} className="text-slate-300 hover:text-white px-4 py-2 rounded-full text-sm font-medium transition-colors flex items-center gap-2 border border-slate-700 hover:border-slate-500" data-id="element-815">
                <LogIn size={16} data-id="element-816" /> Log In
              </button>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden" data-id="element-817">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-300 hover:text-white p-2" data-id="element-818">
              {isOpen ? <X size={24} data-id="element-819" /> : <Menu size={24} data-id="element-820" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="md:hidden bg-slate-900 border-b border-slate-800" data-id="element-821">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-822">
            {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-slate-300 hover:text-cyan-400 block px-3 py-2 rounded-md text-base font-medium" data-id="element-823">
                {link.name}
              </a>)}
            <button onClick={() => {
          setIsOpen(false);
          onLoginClick?.();
        }} className="w-full mt-4 border border-slate-700 text-slate-300 px-5 py-3 rounded-md font-medium flex items-center justify-center gap-2" data-id="element-824">
              <LogIn size={16} data-id="element-825" /> Log In
            </button>
          </div>
        </motion.div>}
    </nav>;
}